"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.SelectElement = exports.SelectLabel = exports.SelectWrapper = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var SelectWrapper = (0, _styled.default)('div')(function (_ref) {
  var mediaQueries = _ref.theme.mediaQueries;
  return _defineProperty({
    display: 'block'
  }, mediaQueries.medium, {
    display: 'inline-block'
  });
});
exports.SelectWrapper = SelectWrapper;
var SelectLabel = (0, _styled.default)('label')(function (_ref3) {
  var space = _ref3.theme.space;
  return {
    display: 'inline-block',
    marginRight: space.small,
    marginBottom: space.small,
    color: 'inherit'
  };
});
exports.SelectLabel = SelectLabel;
var SelectElement = (0, _styled.default)('select')(function (_ref4) {
  var _ref4$theme = _ref4.theme,
      fonts = _ref4$theme.fonts,
      colors = _ref4$theme.colors,
      select = _ref4$theme.select,
      space = _ref4$theme.space;
  return {
    padding: space.base,
    borderRadius: space.small,
    border: "1px solid ".concat(colors[select.borderColor]),
    color: colors[select.color],
    appearance: 'none',
    // This is the base64 code of the down-arrow svg icon
    backgroundImage: 'url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHByZXNlcnZlQXNwZWN0UmF0aW89Im5vbmUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2VXaWR0aD0iMXB4IiBzdHJva2VMaW5lY2FwPSJpbml0aWFsIiBzdHJva2VMaW5lam9pbj0iaW5pdGlhbCI+IDxwYXRoIGQ9Ik02IDlsNiA2IDYtNiIgLz48L3N2Zz4=)',
    backgroundRepeat: 'no-repeat',
    paddingRight: space.xxlarge,
    backgroundPosition: "center right ".concat(space.small),
    backgroundSize: '2.3rem 2.5rem',
    minWidth: '14rem',
    cursor: 'pointer',
    fontFamily: fonts.body,
    fontSize: 'inherit',
    backgroundColor: colors.white
  };
});
exports.SelectElement = SelectElement;